import { render, staticRenderFns } from "./MailSignIn.vue?vue&type=template&id=051ddf01&scoped=true&"
import script from "./MailSignIn.vue?vue&type=script&lang=js&"
export * from "./MailSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ddf01",
  null
  
)

export default component.exports